import { useNavigate } from "react-router-dom"

const TopicsContainer = ({ title, titleClass, links, linkClass }) => {
  const navigate = useNavigate();
  
  const handleNavigate = (link) => {
    navigate(link)
    window.scrollTo(0,0)
  }

  return (
    <div className="help-all-topic-container">
      <p className={`help-all-topic-title ${titleClass}`}>{title}</p>
      {links.map((link, index) => {
        return (
          <div className="" key={index}>
            <p className={`help-all-topic-link ${linkClass}`} onClick={() => handleNavigate(link.url)}>{link.label}</p>
          </div>
        )
      })} 
    </div>
  )
}

export default TopicsContainer